import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import type { ReadonlyURLSearchParams } from "next/navigation";

type PageNavigationContext = {
  router: AppRouterInstance;
  pathname: string;
  searchParams: ReadonlyURLSearchParams;
};

let pageNavigation: PageNavigationContext | null = null;

export const registerPageNavigation = (context: PageNavigationContext): void => {
  pageNavigation = context;
};

export const unregisterPageNavigation = (): void => {
  pageNavigation = null;
};

export const buildPathWithoutEphemeralQuery = (
  pathname: string,
  existing: ReadonlyURLSearchParams | URLSearchParams,
  options?: {
    clearFilters?: boolean;
    clearSort?: boolean;
    clearLayout?: boolean;
  },
): string => {
  const params = new URLSearchParams(existing.toString());
  if (options?.clearFilters !== false) {
    params.delete("filters");
  }
  if (options?.clearSort !== false) {
    params.delete("sort");
  }
  if (options?.clearLayout !== false) {
    params.delete("layout");
  }
  const search = params.toString();
  return search ? `${pathname}?${search}` : pathname;
};

export const clearEphemeralQueryFromUrl = (options?: {
  clearFilters?: boolean;
  clearSort?: boolean;
  clearLayout?: boolean;
}): void => {
  if (pageNavigation) {
    const url = buildPathWithoutEphemeralQuery(
      pageNavigation.pathname,
      pageNavigation.searchParams,
      options,
    );
    pageNavigation.router.replace(url);
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (options?.clearFilters !== false) {
    params.delete("filters");
  }
  if (options?.clearSort !== false) {
    params.delete("sort");
  }
  if (options?.clearLayout !== false) {
    params.delete("layout");
  }
  const search = params.toString();
  const url = search
    ? `${window.location.pathname}?${search}`
    : window.location.pathname;
  window.history.replaceState(window.history.state, "", url);
};
